var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('x-dialog-comp',{attrs:{"title":"全景图"},on:{"on-close":function($event){return _vm.$emit('on-close')}}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.src,"frameborder":"no","border":"0","marginwidth":"0","marginheight":"0","scrolling":"no","allowtransparency":"yes"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }